var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BlockTexto } from './BlockTexto';
import { Align, FontSize, widthPaper } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
export var BlockSeparator = function (_a) {
    var char = _a.char, fontSize = _a.fontSize, bold = _a.bold, maxLeng = _a.maxLeng, align = _a.align, noMarginTop = _a.noMarginTop;
    if (!char || char === '-') {
        return (React.createElement("p", { style: __assign(__assign({}, noMarginTop ? undefined : { marginTop: '10px' }), { width: '95%', height: '1px', background: 'black' }) }, ''));
    }
    var max = maxLeng ? maxLeng : getMaxLength(fontSize);
    var texto = '';
    for (var i = 0; i < max; i++) {
        texto += char;
    }
    return React.createElement(BlockTexto, { texto: texto, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold });
};
var getMaxLength = function (fontSize) {
    var with80 = widthPaper === 80;
    switch (fontSize) {
        case FontSize.smaller:
            return with80 ? 38 : 38;
        case FontSize.small:
            return with80 ? 34 : 34;
        case FontSize.normal:
            return with80 ? 29 : 29;
        case FontSize.big:
            return with80 ? 25 : 25;
        case FontSize.bigger:
            return with80 ? 21 : 21;
        case FontSize.biggest:
            return with80 ? 19 : 19;
        case FontSize.extraBiggest:
            return with80 ? 15 : 15;
        default:
            return with80 ? 29 : 29; // a fontSize normal
    }
};
var defaultProps = {
    fontSize: FontSize.normal,
    bold: false,
    maxLeng: getMaxLength(FontSize.normal),
    align: Align.Center
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockSeparator.tsx
// module id = 102
// module chunks = 0